import { SectionHeader, Reveal } from "../Reveal";

const STEPS = [
  {
    n: "01",
    title: "Votre projet",
    text: "Écoute, découverte de vos besoins et définition de votre stratégie.",
  },
  {
    n: "02",
    title: "Recherche / Vente",
    text: "Sélection des biens ou mise en valeur de votre propriété et recherche des acquéreurs.",
  },
  {
    n: "03",
    title: "Suivi personnalisé",
    text: "Visites, négociation, coordination des différents intervenants et suivi administratif.",
  },
  {
    n: "04",
    title: "Jusqu'à la signature",
    text: "Accompagnement avec le notaire et suivi du dossier jusqu'à la finalisation de votre acquisition ou de votre vente.",
  },
];

export default function Steps() {
  return (
    <section data-testid="steps-section" className="relative overflow-hidden bg-azur py-12 text-sand lg:py-20">
      <img
        src="/kemelia-logo.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -right-28 top-1/2 w-[520px] max-w-none -translate-y-1/2 select-none rounded-full opacity-[0.06]"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeader
          light
          eyebrow="Notre accompagnement"
          title="Bien plus qu'une transaction."
          sub="De la première rencontre à la signature chez le notaire, nous vous accompagnons à chaque étape de votre projet immobilier."
        />
        <div className="mt-16 grid gap-x-10 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div className="group border-t border-white/15 pt-8 transition-colors duration-500 hover:border-gold">
                <span className="outline-number font-serif text-6xl font-light sm:text-7xl">{s.n}</span>
                <h3 className="mt-6 font-serif text-xl font-semibold text-sand sm:text-2xl">{s.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-sand/65">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3} className="mt-16">
          <p className="max-w-2xl font-serif text-xl italic leading-relaxed text-sand/80 sm:text-2xl">
            « Vous ne serez jamais laissé seul après la signature du mandat. »
          </p>
        </Reveal>
      </div>
    </section>
  );
}
